import { FormikProps } from 'formik'
import { FormTextArea } from '../../../../../../../components'

import { FC } from 'react'
import { ResultFormIA } from './ResultadoIAModal'

type IHipoteseIAModal = {
  formik: FormikProps<ResultFormIA>
}

export const HipoteseIAModal: FC<IHipoteseIAModal> = ({ formik }) => (
  <FormTextArea name='diagnostico' placeholder={formik.values.navBar} formik={formik} />
)
